import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import IconPatients from 'components/icons/IconPatients';

const styles = () => ({
  root: {
    minHeight: 330,
  },
  iconPatients: {
    width: 90,
    height: 105,
  },
});

const PatientsDialogListEmpty = ({ classes }) => (
  <Grid
    className={classes.root}
    container
    direction="column"
    justify="center"
    alignItems="center"
    spacing={24}
  >
    <Grid item>
      <IconPatients className={classes.iconPatients} />
    </Grid>
    <Grid item>
      <Typography variant="subheading" color="secondary">
        Unfortunately, there are no patients with such name
      </Typography>
    </Grid>
  </Grid>
);

PatientsDialogListEmpty.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    iconPatients: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(PatientsDialogListEmpty);



// WEBPACK FOOTER //
// ./src/components/patient/PatientsDialog/PatientsDialogListEmpty.js